/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { ContractWorkRate } from './';
import {
    ContractWorkRateFromJSON,
    ContractWorkRateFromJSONTyped,
    ContractWorkRateToJSON,
} from './';

/**
 * 
 * @export
 * @interface TimeAndMaterialsProjectContractDetailsResource
 */
export interface TimeAndMaterialsProjectContractDetailsResource {
    /**
     * 
     * @type {string}
     * @memberof TimeAndMaterialsProjectContractDetailsResource
     */
    projectScope?: string;
    /**
     * 
     * @type {ContractWorkRate}
     * @memberof TimeAndMaterialsProjectContractDetailsResource
     */
    workRate?: ContractWorkRate;
    /**
     * 
     * @type {Date}
     * @memberof TimeAndMaterialsProjectContractDetailsResource
     */
    startDate?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TimeAndMaterialsProjectContractDetailsResource
     */
    estimatedEndDate?: Date;
    /**
     * 
     * @type {number}
     * @memberof TimeAndMaterialsProjectContractDetailsResource
     */
    estimatedTotalWorkAmount?: number;
    /**
     * 
     * @type {number}
     * @memberof TimeAndMaterialsProjectContractDetailsResource
     */
    vatPercent?: number;
}

/**
 * Check if a given object implements the TimeAndMaterialsProjectContractDetailsResource interface.
 */
export function instanceOfTimeAndMaterialsProjectContractDetailsResource(value: object): value is TimeAndMaterialsProjectContractDetailsResource {
    return true;
}

export function TimeAndMaterialsProjectContractDetailsResourceFromJSON(json: any): TimeAndMaterialsProjectContractDetailsResource {
    return TimeAndMaterialsProjectContractDetailsResourceFromJSONTyped(json, false);
}

export function TimeAndMaterialsProjectContractDetailsResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): TimeAndMaterialsProjectContractDetailsResource {
    if (json == null) {
        return json;
    }
    return {
        
        'projectScope': json['projectScope'] == null ? undefined : json['projectScope'],
        'workRate': json['workRate'] == null ? undefined : ContractWorkRateFromJSON(json['workRate']),
        'startDate': json['startDate'] == null ? undefined : (new Date(json['startDate'])),
        'estimatedEndDate': json['estimatedEndDate'] == null ? undefined : (new Date(json['estimatedEndDate'])),
        'estimatedTotalWorkAmount': json['estimatedTotalWorkAmount'] == null ? undefined : json['estimatedTotalWorkAmount'],
        'vatPercent': json['vatPercent'] == null ? undefined : json['vatPercent'],
    };
}

export function TimeAndMaterialsProjectContractDetailsResourceToJSON(value?: TimeAndMaterialsProjectContractDetailsResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'projectScope': value['projectScope'],
        'workRate': ContractWorkRateToJSON(value['workRate']),
        'startDate': value['startDate'] == null ? undefined : ((value['startDate']).toISOString().substring(0,10)),
        'estimatedEndDate': value['estimatedEndDate'] == null ? undefined : ((value['estimatedEndDate']).toISOString().substring(0,10)),
        'estimatedTotalWorkAmount': value['estimatedTotalWorkAmount'],
        'vatPercent': value['vatPercent'],
    };
}

